module.exports = __webpack_public_path__ + "img/needle.251f63e6.svg";